module.exports = __webpack_public_path__ + "static/img/1.db5d7e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/1.png
// module id = 8SzS
// module chunks = 0